export default __webpack_public_path__ + "static/media/iyyara_thumb.b49f1109.jpg";